import React, { useRef, useState } from "react";
import { Upload } from "antd";
import { Button, CircularProgress } from "@material-ui/core";
import localforage from "localforage";
import { useTranslation } from "@/langs/useTranslation";
import { CloseOutlined } from "@material-ui/icons";
import { toast } from "@/apis/request";
import { IconFileExcel, IconXls } from "@/components/Icon";
import SubmitButton from "@/components/commons/SubmitButton";
import { importGroupsAPI } from "@/apis/apiCollection";
import styles from "./index.module.less";

const { Dragger } = Upload;

function ImportGroups({ groupId, onSuccess, onCancel }) {
  const { t } = useTranslation();
  const fileRef = useRef(null);
  const [fileInfo, setFileInfo] = useState({});
  const [loading, setLoading] = useState(false);

  const uploadProps = {
    name: "file",
    multiple: false,
    disabled: loading,
    className: styles.upload,
    accept: ".xlsx,.xlsm,.xlsb,.xltx,.xls,.xlt",
    beforeUpload: file => {
      if (/\.(xlsx|xlsm|xlsb|xltx|xls|xlt)$/i.test(file.name)) {
        setFileInfo({
          name: file.name
        });
        fileRef.current = file;
      } else {
        toast.warning(
          t({
            defaultMessage: "请选择Excel文件"
          })
        );
      }
      return false;
    },
    fileList: []
  };

  const handleImport = async () => {
    if (!fileRef.current)
      return toast.info(t({ defaultMessage: "没有选择要导入的文件" }));
    try {
      setLoading(true);
      const formData = new FormData();
      const currentCompanyId = await localforage.getItem("currentCompanyId");
      formData.append("spreadsheet", fileRef.current);
      formData.append("group_id", groupId);
      formData.append("company_id", currentCompanyId);
      const res = await importGroupsAPI(formData);
      onSuccess?.(res);
      onCancel();
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = e => {
    e.stopPropagation();
    setFileInfo({});
    fileRef.current = null;
  };

  return (
    <>
      <Dragger {...uploadProps}>
        <div className={styles.draggerWrap}>
          <div style={{ fontSize: 56, height: 56, marginBottom: 20 }}>
            <IconFileExcel />
          </div>
          {fileInfo.name ? (
            <>
              {loading ? (
                <div>
                  <CircularProgress size={14} style={{ marginRight: 10 }} />
                  {t({ defaultMessage: "正在上传" })}
                </div>
              ) : (
                <div className={styles.desc} style={{ fontSize: 14 }}>
                  {fileInfo.name}
                </div>
              )}
              {!loading && (
                <span className={styles.remove} onClick={handleRemove}>
                  <CloseOutlined />
                </span>
              )}
            </>
          ) : (
            <>
              <p className={styles.desc} style={{ fontSize: 14 }}>
                {t({ defaultMessage: "将文件拖到此处 或点击上传" })}
              </p>
              <p className={styles.desc}>
                {t({ defaultMessage: "支持格式：xls、xlsx" })}
              </p>
            </>
          )}
        </div>
      </Dragger>
      <div className={styles.downloadTemplate}>
        <div>
          <IconXls size={20} style={{ marginRight: 8 }} />
          <span className={styles.title}>{t({ defaultMessage: "范本" })}</span>
          <div className={styles.desc}>
            {t({ defaultMessage: "下载范本，根据范本提示完善内容" })}
          </div>
        </div>
        <Button
          variant="outlined"
          style={{ width: 100 }}
          href="/templates/groups.xlsx"
        >
          {t({ defaultMessage: "下载" })}
        </Button>
      </div>
      <div className={styles.footer}>
        <SubmitButton
          color="primary"
          size="large"
          variant="contained"
          onClick={handleImport}
          loading={loading}
        >
          {t({ defaultMessage: "确定" })}
        </SubmitButton>
        <Button variant="outlined" size="large" onClick={onCancel}>
          {t({ defaultMessage: "取消" })}
        </Button>
      </div>
    </>
  );
}

export default ImportGroups;
